<template>
  <div>
    <div class="home d-flex">
      <video playsinline autoplay muted loop poster="../assets/video/bory-video-cover.jpeg" id="bgvid">
        <source src="../assets/video/bory-video.webm" type="video/webm">
        <source src="../assets/video/bory-video.mp4" type="video/mp4">
      </video>
      <div class="intro-text d-flex align-items-end px-md-5">
        <div>
          <h1>{{ $t('Bory Nový Dvor') }}</h1>
          <p>{{ $t('Bývajte s vodou priamo pod oknami.') }}
          </p>
          <b-button href="https://borybyvanie.sk/nasa-stvrt" target="_blank" class="d-block d-md-inline-block" squared variant="primary">{{ $t('O bývaní na Boroch') }}</b-button>
          <!--          <b-button class="d-block d-md-inline-block ml-md-3 mt-2 mt-md-0" squared variant="light">Stiahnuť brožúru</b-button>-->
        </div>
      </div>
    </div>

    <section class="district p-md-3 pt-3 pt-md-5">
      <div class="d-flex flex-wrap align-items-start top mb-5">
        <div class="col-md-6 px-md-5">
          <h2 class="mb-4 m-md-0">{{$t('Mesto tak, ako ho poznáte')}}</h2>
        </div>
        <div class="col-md-6 d-flex justify-content-center">
          <p class="m-0">{{ $t('Bory kombinujú aktívne rodinné bývanie') }}</p>
        </div>
      </div>
    </section>

    <ScheduleTimeline :phases="schedulePhases" />

    <section class="section-3 p-3">
      <div class="">
        <div class="row px-3 mb-3">
          <div class="col-md-7 bg-img"></div>
          <div class="col-md-5 p-0 px-md-5 py-3">
            <h2 v-html="$t('Buďte pri tom,<br> čo vás baví')"></h2>
            <p>{{ $t('Bory Nový Dvor je so svojimi ihriskami a zeleňou') }}</p>
          </div>
        </div>
        <div class="row px-2">
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-1">
              <h3 v-html="$t('20 000 m2<br> zelene')"></h3>
              <p>{{ $t('Beh, cyklistika aj oddych.') }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-2">
              <h3 v-html="$t('Jazierko<br> pred domom')"></h3>
              <p>{{ $t('Súčasťou areálu je jazierko') }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-3">
              <h3 v-html="$t('Autom<br> až domov')"></h3>
              <p>{{ $t('Pohodlné parkovanie v bezprostrednej blízkosti') }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="about-bottom p-md-3 pl-md-5">
      <div class="d-flex flex-wrap">
        <div class="col-md-4 py-5">
          <h2 class="mb-4">{{ $t('Domov, ktorý vydrží') }}</h2>
          <p class="mb-5">{{ $t('Na materiáloch, ktorých sa každý deň dotýkate, záleží') }}</p>
          <!--          <b-button squared variant="primary">Stiahnuť katalóg štandardov</b-button>-->
        </div>
        <div class="col-md-8 pb-3 pb-md-0 pr-md-0 right-img">
        </div>
      </div>
    </section>

    <section class="about-bottom-2">
      <div class="d-flex flex-wrap">
        <div class="col-md-6 bg"></div>
        <div class="col-md-6 signature-section">
          <p class="mb-4">{{ $t('Cieľom návrhu je priniesť kvalitný verejný priestor') }}</p>
          <p class="name">Sadovsky&Architects</p>
          <p class="name">Peter Hubinský, Dalibor Špilák, Oliver Sadovský</p>
        </div>
      </div>
    </section>

    <ContactForm selectedStage="bory2b"></ContactForm>
  </div>
</template>

<script>
import ScrollTo from "@/utils/scrollTo.util";
import ContactForm from "@/components/shared/ContactForm";
import ScheduleTimeline from "@/components/home/ScheduleTimeline";
export default {
  name: "NovyDvor",
  components: {ContactForm, ScheduleTimeline},
  data() {
    return {
      schedulePhases: [
        { icon: 'zahajenie-vystavby', title: 'Začiatok<br> výstavby', date: '3. kvartál 2018', status: 'fill', round: 1 },
        { icon: 'hruba-stavba', title: 'Koniec<br> výstavby', date: '3. kvartál 2020', status: 'fill', round: 1 },
        { icon: 'kolaudacia', title: 'Kolaudačný<br> proces', date: '4. kvartál 2020', status: 'fill', round: 1 },
        { icon: 'odovzdanie-bytov', title: 'Odovzdávanie<br> bytov', date: '1-2. kvartál 2021', status: 'fill', round: 1 },
        { icon: 'zahajenie-vystavby', title: 'Začiatok<br> výstavby', date: '1. kvartál 2021', status: 'fill', round: 2 },
        { icon: 'hruba-stavba', title: 'Koniec<br> výstavby', date: '2. kvartál 2023', status: 'fill', round: 2 },
        { icon: 'kolaudacia', title: 'Kolaudačný<br> proces', date: '3. kvartál 2023', status: 'fill', round: 2 },
        { icon: 'odovzdanie-bytov', title: 'Odovzdávanie<br> bytov', date: '4. kvartál 2023', status: 'fill', round: 2 },
        { icon: 'kluce-byvanie', title: 'Vaše<br> bývanie', status: 'fill', round: 0 }
      ]
    }
  },
  mounted() {
    ScrollTo.hash(this,  () => window.scrollTo(0, 0))
  }
}
</script>

<style lang="sass" scoped>
$md: 768px
$large: 1180px

video
  object-fit: cover
  width: 100vw
  height: 100vh
  position: absolute
  top: 0
  left: 0
.about-bottom-2
  .bg
    background: url(../assets/images/bory_playground_big.jpg) bottom/cover no-repeat
.about-bottom
  padding-bottom: 11px!important
  .right-img
    min-height: auto
    background: url(../assets/images/bory-jazierko/bory-standard.jpg) center/cover no-repeat
.section-3
  background: var(--grey)
  color: #fff
  text-align: left
  .bg-img
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory_caffe_land.jpg") bottom/cover no-repeat
    @media (max-width: $md)
      height: 40vh
      background-size: cover
  h2
    font-size: 55px
    line-height: 60px
    font-weight: 300
    margin-bottom: 20px
    @media (max-width: $md)
      font-size: 28px
      line-height: 40px
      letter-spacing: -1px
      margin-bottom: 15px
  p
    max-width: 320px
    font-weight: 500
    &:last-child
      margin-bottom: 220px
      @media (max-width: $md)
        margin-bottom: 0
  .bg-col
    height: 800px
    @media (max-width: $md)
      height: 60vh
      margin-bottom: 16px
      padding: 30px
    h3
      font-size: 28px
      line-height: 32px
      font-weight: 400
      margin-bottom: 20px
    p
      font-size: 16px
      line-height: 21px
      font-weight: 500
      @media (max-width: $md)
        font-size: 12px
        line-height: 16px
        max-width: 100%
  .bg-col-1
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory_courtyard.jpg") center/cover no-repeat
  .bg-col-2
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory_lake2.jpg") center/cover no-repeat
  .bg-col-3
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory_caffe.jpg") center/cover no-repeat
  .col-md-4
    padding-left: 8px
    padding-right: 8px
.home
  background: url("../assets/images/bory_lake_flip.jpg") bottom/cover no-repeat
  .intro-text
    position: relative
  p
    margin-bottom: 30px
    max-width: 770px

.district
  background: var(--darkBlue)
  img
    width: 100%
.top
  h2
    font-weight: 300
    font-size: 55px
    line-height: 60px
    letter-spacing: -3px
    @media (max-width: $md)
      font-size: 40px
      line-height: 40px
      letter-spacing: -2px
  p
    font-weight: 500
    max-width: 415px
</style>
